import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";

interface Props {
  user: { id: number; username: string };
  onLogout: () => void;
  children: ReactNode;
}

export default function Layout({ user, onLogout, children }: Props) {
  return (
    <div className="app">
      <aside className="sidebar">
        <h1>pg-backup</h1>
        <nav>
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/schedules">Schedules</NavLink>
          <NavLink to="/runs">Runs</NavLink>
          <NavLink to="/backups">Backups</NavLink>
          <NavLink to="/settings">Settings</NavLink>
        </nav>
        <div className="spacer" />
        <div className="footer">
          signed in as <strong>{user.username}</strong>
          <button onClick={onLogout} style={{ width: "100%" }}>Sign out</button>
        </div>
      </aside>
      <main>{children}</main>
    </div>
  );
}
